"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableCell = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TableCellMixin = require("../../mixins/components/TableCellMixin");
var StyledTableCell = /*#__PURE__*/_styledComponents.default.td.withConfig({
  displayName: "StyledTableCell",
  componentId: "c11n-8-107-0__sc-1ijd1ns-0"
})(["", ""], _TableCellMixin.TableCellMixin);
exports.StyledTableCell = StyledTableCell;